<template>
  <div class="modal">
    <div class="modal-window">
      <span class="close" @click="$emit('close')">
        <font-awesome-icon icon="times"/>
      </span>
      <div class="top-line text">
        Вы хотите добавить уже существующего участника или создать нового?
      </div>
      <div>
        <router-link :to="{name: 'GroupPlayers'}">
          <div class="btn" style="background-color: #fff">
            Выбрать из списка
          </div>
        </router-link>
        <router-link :to="{name: 'NewGroupPlayer'}">
          <div class="btn">
            Создать нового участника
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupModal'
}
</script>

<style scoped lang="scss">
  span.close {
    position: absolute;
    right: 30px;
    top: 20px;
    cursor: pointer;
  }

  .text {
    font-size: 22px;
    font-weight: 300;
  }

  .btn {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
    margin: 0 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/GroupModal.vue